module.exports = __webpack_public_path__ + "img/icon-user-outline.8b5e3fde.svg";